import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../success/success-minimal.css";

// Generic cancel page (no external verification)
const Cancel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [redirectPath, setRedirectPath] = useState("/event");

  // Detect reservation redirect and forward to reservation cancel page
  const reservationReturn = useMemo(() => {
    try {
      const sp = new URLSearchParams(location.search || "");
      const orderId = sp.get("orderId") || sp.get("orderID") || sp.get("order") || sp.get("oid") || sp.get("reservationCode") || "";
      const raw = sessionStorage.getItem("reservation:last");
      const parsed = raw ? JSON.parse(raw) : null;
      if (parsed?.flow === "reservas" && parsed?.reservationCode) {
        if (!orderId || String(parsed.reservationCode) === String(orderId)) {
          return parsed;
        }
      }
      if (sp.get("reservationCode") && sp.get("barId")) {
        return {
          flow: "reservas",
          reservationCode: sp.get("reservationCode"),
          barId: sp.get("barId"),
        };
      }
      return null;
    } catch (_) {
      return null;
    }
  }, [location.search]);

  useEffect(() => {
    if (reservationReturn) {
      navigate(`/reservas/cancel${location.search || ""}`, { replace: true });
    }
  }, [reservationReturn, navigate, location.search]);

  // Try to infer the event we were checking out
  const qsEventId = useMemo(() => {
    try {
      const sp = new URLSearchParams(location.search || "");
      return (
        sp.get("eventId") || sp.get("eventid") || sp.get("eid") || ""
      );
    } catch (_) { return ""; }
  }, [location.search]);

  useEffect(() => {
    if (reservationReturn) return;
    try {
      // Prefer explicit query string
      let evId = qsEventId || "";
      if (!evId) {
        // Then last checkout context
        try {
          const ctx = JSON.parse(localStorage.getItem("lastCheckoutCtx") || "null");
          if (ctx?.eventId) evId = ctx.eventId;
        } catch {}
      }
      if (!evId) {
        // Pending checkout snapshot (pre-login)
        try {
          const p = JSON.parse(localStorage.getItem("pendingCheckout") || "null");
          if (p?.eventId) evId = p.eventId;
        } catch {}
      }
      if (!evId) {
        // Last event page visited
        try {
          const last = localStorage.getItem("lastEventId");
          if (last) evId = last;
        } catch {}
      }
      const path = evId ? `/event/${evId}` : "/event";
      setRedirectPath(path);
      const timeout = setTimeout(() => navigate(path, { replace: true }), 6000);
      return () => clearTimeout(timeout);
    } catch (_) {
      const timeout = setTimeout(() => navigate("/event", { replace: true }), 6000);
      return () => clearTimeout(timeout);
    }
  }, [navigate, location.search, qsEventId, reservationReturn]);

  if (reservationReturn) {
    return null;
  }

  return (
    <div className="success-minimal">
      <div className="success-minimal-card">
        <svg
          className="success-minimal-icon"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 10h6l6 30h28l6-18H20"
            stroke="#E53935"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line x1="22" y1="18" x2="30" y2="26" stroke="#E53935" strokeWidth="3" />
          <line x1="30" y1="18" x2="22" y2="26" stroke="#E53935" strokeWidth="3" />
          <circle cx="26" cy="52" r="3" stroke="#E53935" strokeWidth="3" />
          <circle cx="46" cy="52" r="3" stroke="#E53935" strokeWidth="3" />
        </svg>
        <h2 className="error-minimal-title">¡Ups! Algo salió mal</h2>
        <p className="error-minimal-subtext">
          No pudimos procesar el pago, intentá de nuevo en unos minutos.
        </p>
        <button className="success-minimal-btn" onClick={() => navigate(redirectPath)}>Reintentar pago</button>
        <div className="success-minimal-note">
          <span>
            <i>i</i> Si el problema persiste, contactá a <a href="/contact-us"><strong>nuestro soporte</strong></a>.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
